import { lazy } from 'react';
export const CatalogPage = lazy(() =>
  import('./index').then(m => ({ default: m.CatalogPage })),
);
